import {
    CalendarDaysIcon,
    ClipboardListIcon,
    HeartPulseIcon,
    PaperclipIcon,
    PenLineIcon,
    ShieldCheckIcon,
    ShirtIcon,
    UserIcon,
    UsersIcon,
} from 'lucide-react';

export const sectionIcons = {
    user: UserIcon,
    shield: ShieldCheckIcon,
    calendar: CalendarDaysIcon,
    whistle: ClipboardListIcon,
    shirt: ShirtIcon,
    users: UsersIcon,
    heart: HeartPulseIcon,
    paperclip: PaperclipIcon,
    signature: PenLineIcon,
};
